import { tokens } from "shared/components/Spor";
import { appPalette } from "shared/theme/colors/appPalette";
import { mapValues } from "shared/utils/arrayUtils";
// After SporV2 we need to retrieve the colors directly from palette
const { palette } = tokens.default.color;
const alias = mapValues(tokens.default.color.alias, (value) => {
  const [_, color, strength] = value.split(".");
  return (palette as any)[color][strength];
});

const colors = {
  ...appPalette,
  ...alias,
  ...palette,
};

export default colors;
